"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Placement = require("./utils/Placement");

var _Use = require("./utils/Use");

var _PlacementConstants = require("./PlacementConstants");

var _Styles = require("../utils/Styles");

var _colors = require("HubStyleTokens/colors");

function _templateObject11() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: absolute;\n  pointer-events: none;\n\n  border: ", ";\n  border-top-left-radius: 100%;\n  border-top-color: transparent !important;\n  border-left-color: transparent !important;\n  border-bottom-right-radius: ", ";\n\n  width: ", ";\n  height: ", ";\n  background-color: ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n        left: ", "px;\n      "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n        left: calc(50% - ", "px);\n      "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n        right: ", "px;\n      "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n        top: ", "px;\n      "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n        top: calc(50% - ", "px);\n      "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n        bottom: ", "px;\n      "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n        transform: rotate(-45deg);\n        left: calc(100% - ", "px);\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n        transform: rotate(-135deg);\n        top: -", "px;\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n        transform: rotate(135deg);\n        left: -", "px;\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n        transform: rotate(45deg);\n        top: calc(100% - ", "px);\n      "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var mediumArrowSize = 16;
var smallArrowSize = 12;

var isShepherdArrowWhite = function isShepherdArrowWhite(placement) {
  return placement.includes('top');
};

var getBackgroundColor = function getBackgroundColor(_ref) {
  var color = _ref.color,
      placement = _ref.placement,
      popoverUse = _ref.popoverUse;

  if (color) {
    return color;
  }

  if (popoverUse === 'shepherd') {
    return isShepherdArrowWhite(placement) ? _colors.OLAF : _colors.THUNDERDOME;
  }

  return 'inherit';
};

var getSideStyles = function getSideStyles(_ref2) {
  var placement = _ref2.placement,
      width = _ref2.width;

  switch ((0, _Placement.getSide)(placement)) {
    case 'top':
      // Arrow points down
      return (0, _styledComponents.css)(_templateObject(), width / 2);

    case 'right':
      // Arrow points left
      return (0, _styledComponents.css)(_templateObject2(), width / 2);

    case 'bottom':
      // Arrow points up
      return (0, _styledComponents.css)(_templateObject3(), width / 2);

    case 'left':
      // Arrow points right
      return (0, _styledComponents.css)(_templateObject4(), width / 2);

    default:
      return '';
  }
};

var getEdgeStyles = function getEdgeStyles(_ref3) {
  var inset = _ref3.inset,
      placement = _ref3.placement,
      width = _ref3.width;
  // Magic calculation, haven't quite figured this out yet
  var adjustedInset = inset + 3;

  switch ((0, _Placement.getEdge)(placement)) {
    case 'top':
      // Arrow is near the bottom of the left or right side
      return (0, _styledComponents.css)(_templateObject5(), adjustedInset);

    case 'middle':
      return (0, _styledComponents.css)(_templateObject6(), width / 2);

    case 'bottom':
      // Arrow is near the top of the left or right side
      return (0, _styledComponents.css)(_templateObject7(), adjustedInset);

    case 'left':
      // Arrow is near the right of the top or bottom side
      return (0, _styledComponents.css)(_templateObject8(), adjustedInset);

    case 'center':
      return (0, _styledComponents.css)(_templateObject9(), width / 2);

    case 'right':
      // Arrow is near the left of the top or bottom side
      return (0, _styledComponents.css)(_templateObject10(), adjustedInset);

    default:
      return '';
  }
};

var getBorderUseStyles = function getBorderUseStyles(_ref4) {
  var placement = _ref4.placement,
      popoverUse = _ref4.popoverUse;

  if (popoverUse === 'default' || popoverUse === 'longform' || popoverUse === 'shepherd' && isShepherdArrowWhite(placement)) {
    return "1px solid " + _colors.BATTLESHIP;
  }

  return null;
};

var Arrow = _styledComponents.default.div.withConfig({
  displayName: "UIPopoverArrow__Arrow",
  componentId: "sc-1e82llc-0"
})(_templateObject11(), getBorderUseStyles, function (_ref5) {
  var popoverUse = _ref5.popoverUse;
  return popoverUse === 'tooltip' || popoverUse === 'tooltip-danger' ? '3px' : null;
}, function (_ref6) {
  var width = _ref6.width;
  return (0, _Styles.toPx)(width);
}, function (_ref7) {
  var width = _ref7.width;
  return (0, _Styles.toPx)(width);
}, getBackgroundColor, getSideStyles, getEdgeStyles);

var UIPopoverArrow =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(UIPopoverArrow, _PureComponent);

  function UIPopoverArrow() {
    (0, _classCallCheck2.default)(this, UIPopoverArrow);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIPopoverArrow).apply(this, arguments));
  }

  (0, _createClass2.default)(UIPopoverArrow, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          width = _this$props.width,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["className", "width"]);

      if (width === 0) {
        return null;
      }

      return _react.default.createElement(Arrow, (0, _extends2.default)({}, rest, {
        className: (0, _classNames.default)('uiPopoverArrow private-popover__arrow', className),
        width: width
      }));
    }
  }]);
  return UIPopoverArrow;
}(_react.PureComponent);

UIPopoverArrow.propTypes = {
  color: _react.PropTypes.string,
  inset: _react.PropTypes.number.isRequired,
  placement: _react.PropTypes.oneOf(_PlacementConstants.PLACEMENTS).isRequired,
  popoverUse: _react.PropTypes.oneOf(Object.keys(_Use.USE_CLASSES)),
  width: _react.PropTypes.number
};
UIPopoverArrow.defaultProps = {
  inset: 0,
  placement: 'top',
  width: 20
};
UIPopoverArrow.ARROW_SIZES = {
  none: {
    distance: 4,
    inset: 0,
    width: 0
  },
  medium: {
    distance: mediumArrowSize,
    inset: mediumArrowSize - 2,
    width: 20
  },
  small: {
    distance: smallArrowSize,
    inset: smallArrowSize - 2,
    width: 16
  }
};
UIPopoverArrow.displayName = 'UIPopoverArrow';
var _default = UIPopoverArrow;
exports.default = _default;
module.exports = exports.default;